"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCatalogueItemFromId = exports.makeIdFromCatalogueProps = void 0;
const effect_1 = require("effect");
/**
 * Utility function to derive a `Schema` from {@link CatalogueProps}, keeping
 * `keyof catalogue` as is, and transforming `keyof legacyCatalogueItemIdMap`
 * into `keyof catalogue`
 */
const makeIdFromCatalogueProps = ({ catalogue, legacyCatalogueItemIdMap, }) => effect_1.Schema.Union(...(0, effect_1.pipe)(catalogue, effect_1.Record.toEntries, effect_1.Array.map(([id, { name }]) => effect_1.Schema.Literal(id).annotations({ title: `Unique identifier for: "${name}"` }))), ...(0, effect_1.pipe)(legacyCatalogueItemIdMap, effect_1.Record.toEntries, effect_1.Array.map(([fromId, toId]) => effect_1.Schema.transformLiteral(fromId, toId).annotations({
    title: `Unique identifier for: "${catalogue[toId].name}"`,
    description: `Legacy - use \`${toId}\` instead`,
}))));
exports.makeIdFromCatalogueProps = makeIdFromCatalogueProps;
const makeCatalogueItemFromId = (ConsumableConstructor) => effect_1.Schema.transform((0, exports.makeIdFromCatalogueProps)(ConsumableConstructor), ConsumableConstructor.pipe(effect_1.Schema.asSchema, effect_1.Schema.typeSchema), {
    strict: true,
    decode: id => ConsumableConstructor.catalogue[id],
    encode: ({ id }) => id,
}).annotations({
    arbitrary: () => fc => fc.constantFrom(...effect_1.Record.values(ConsumableConstructor.catalogue)),
});
exports.makeCatalogueItemFromId = makeCatalogueItemFromId;
//# sourceMappingURL=_util.js.map